var map = {
	"./icon-element-Anemo.webp": 5732,
	"./icon-element-Bow.webp": 8082,
	"./icon-element-Catalyst.webp": 756,
	"./icon-element-Claymore.webp": 202,
	"./icon-element-Cryo.webp": 3075,
	"./icon-element-Dendro.webp": 9603,
	"./icon-element-Electro.webp": 6995,
	"./icon-element-Geo.webp": 975,
	"./icon-element-Hydro.webp": 3262,
	"./icon-element-Polearm.webp": 8204,
	"./icon-element-Pyro.webp": 1544,
	"./icon-element-Sword.webp": 2863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4475;